 import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message } from "antd";
import moment from 'moment'

import EachSyncReport from './EachSyncReport/EachSyncReport';
import { fetchSyncInfo } from "../../../actions/sync-info";
import { refresh_profile } from "../../../actions/auth";
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import './SyncList.scss';

// This component gets all the information to create reports
class SyncList extends Component{

    constructor(props) {
        super();
        const { user } = props;

        this.state={
            syncInfoList:[],
            sync_frequency:[
                {
                    id : 1,
                    title : "Every Day"
                },
                {
                    id : 2,
                    title : "Every Week"
                },
                {
                    id : 3,
                    title : "Every Month"
                }]
    
         }
    }

    componentDidMount() {
        this.props.fetchSyncInfo();
        this.props.refresh_profile(true);
    
    }

    componentWillReceiveProps({ syncInfo, user }) {
        if (syncInfo.error) {
          message.error(syncInfo.error);
        } else {
          this.setState({
            syncInfoList: syncInfo.items,
            user
          });

        }

    }    



    handleDeleteClick  = (syncId) => {
        
        CloudFlyerAPI
        .user_account
        .deleteSync(syncId)
        .then(response => {
            message.success("Sync Information deleted successfully!")
            this.props.fetchSyncInfo();
        })
        .catch(err => {
            message.error("Something went wrong.")
        })
    
        
    }

    render(){
        const syncTableHeader = <ul>
                                    <li>Source</li>
                                    <li>Destination</li>
                                    <li>Sync Frequency</li>
                                    <li>Sync Date/Time</li>
                                    <li>Actions</li>
                                </ul>

        const syncList=this.state.syncInfoList.map((sl,index) =>{
            let syncF = this.state.sync_frequency.find(sf => sf.id === sl.frequency)  ||  {}
            return (
                <EachSyncReport
                    source={sl.source_bucket}
                    destination={sl.destination_bucket}
                    syncFrequency={ syncF.title}
                    date={moment(sl.created_date).format('MMMM Do YYYY, h:mm:ss a')}
                    id = {sl.id}
                    key={index}
                    handleDeleteClick = {this.handleDeleteClick}
                />
            )
        })

        return(
            <div className={"syncWrapper"}>
                <div className={"syncTableHeader"}>
                    {syncTableHeader}
                </div>
                <div className="syncListWrapper">
                    {syncList}
                </div>
            </div>
        )
    }
}


function mapStateToProps({ syncInfo, auth: { user } = {} }) {
    return { syncInfo, user };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        fetchSyncInfo: bindActionCreators(fetchSyncInfo, dispatch),
        refresh_profile
    };
  }
  
  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SyncList)
  );
